import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ColorMatchResultPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // Accept both hex and product modes
  const color = location.state?.color || location.state?.product?.shadeHex || "#ffffff";
  const product = location.state?.product;
  const lab = location.state?.lab;
  const matches = location.state?.matches || [];

  if (!color && !product) {
    return (
      <div>
        <p>No color selected. Please <button onClick={() => navigate('/colormatch')}>go back</button> and select a color.</p>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 850, margin: '2rem auto', padding: '2rem 1rem' }}>
      {/* Target ("Selected") Color Info */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 32 }}>
        <div
          style={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            background: color,
            marginRight: 22,
            border: '2px solid #bbb'
          }}
        />
        <div>
          {product ? (
            <>
              <div style={{ fontWeight: 700, fontSize: 20 }}>
                {product.brand} — {product.product}
              </div>
              <div>Shade: <b>{product.shade}</b></div>
              <div>HEX: <span style={{ fontFamily: 'monospace' }}>{product.shadeHex}</span></div>
            </>
          ) : (
            <>
              <div style={{ fontWeight: 700, fontSize: 20 }}>
                {color}
              </div>
            </>
          )}
          {lab && (
            <div>LAB: <span style={{ fontFamily: 'monospace' }}>{lab.map(x => x.toFixed(2)).join(', ')}</span></div>
          )}
        </div>
      </div>

      <h4>Closest Product Matches</h4>
      {matches.length === 0 ? (
        <p>No matches found.</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table className="table table-bordered" style={{ minWidth: 520 }}>
            <thead>
              <tr>
                <th>Brand</th>
                <th>Product</th>
                <th>Shade</th>
                <th>Percent Match</th>
              </tr>
            </thead>
            <tbody>
              {matches.map((m, idx) => (
                <tr key={idx}>
                  <td>{m.Brand}</td>
                  <td>{m.Product}</td>
                  <td>{m.Shade}</td>
                  <td>{m['Percent Match']}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <button style={{background:"#7C5869"}} className="btn btn-secondary mt-3" onClick={() => navigate(-1)}>
        Start New Search
      </button>
    </div>
  );
};

export default ColorMatchResultPage;
